/**
 * Skrin set semula kata laluan.
 *
 * Pemilik yang lupa kata laluan tidak sepatutnya perlu menyunting pangkalan data. Pautan daripada
 * e-mel membawa token; skrin ini menukar kata laluan dan kemudian menghantar pemilik kembali ke
 * back office untuk log masuk dengan kata laluan baharu.
 */

import { useState } from 'react';
import { API_BASE } from '../config.js';

interface Props {
  onDone: () => void;
}

function tokenFromUrl(): string {
  return new URLSearchParams(window.location.search).get('token') ?? '';
}

export function ResetPasswordScreen({ onDone }: Props): React.ReactElement {
  const [token] = useState(tokenFromUrl);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(): Promise<void> {
    setError(null);
    if (password.length < 10) {
      setError('Kata laluan mesti sekurang-kurangnya 10 aksara.');
      return;
    }
    if (password !== confirm) {
      setError('Kata laluan dan ulangannya tidak sepadan.');
      return;
    }
    setBusy(true);
    try {
      const response = await fetch(`${API_BASE}/v1/auth/reset-password`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      if (!response.ok) {
        const body = (await response.json().catch(() => null)) as { error?: { message?: string } } | null;
        throw new Error(body?.error?.message ?? 'Pautan tidak sah atau sudah tamat.');
      }
      setDone(true);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Gagal menukar kata laluan.');
    } finally {
      setBusy(false);
    }
  }

  if (token === '') {
    return (
      <div className="center">
        <h1>Pautan tidak lengkap</h1>
        <p className="muted">
          Buka pautan daripada e-mel set semula. Jika pautan tiada, minta yang baharu di halaman log
          masuk.
        </p>
        <button type="button" className="ghost" onClick={onDone}>
          Kembali ke log masuk
        </button>
      </div>
    );
  }

  if (done) {
    return (
      <div className="center">
        <h1>Kata laluan ditukar</h1>
        <p className="muted">
          Semua sesi lama telah dibatalkan. Log masuk semula dengan kata laluan baharu.
        </p>
        <button type="button" onClick={onDone}>
          Ke log masuk
        </button>
      </div>
    );
  }

  return (
    <div className="center">
      <h1>Kata laluan baharu</h1>
      <p className="muted">Minimum 10 aksara. Semua sesi lain akan dilog keluar.</p>
      <label>
        Kata laluan baharu
        <input
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
      </label>
      <label>
        Ulang kata laluan baharu
        <input
          type="password"
          autoComplete="new-password"
          value={confirm}
          onChange={(event) => setConfirm(event.target.value)}
        />
      </label>
      {error !== null && <p className="error">{error}</p>}
      <button type="button" disabled={busy} onClick={() => void submit()}>
        {busy ? 'Menyimpan…' : 'Simpan kata laluan'}
      </button>
    </div>
  );
}
